module.exports = __webpack_public_path__ + "img/done.cf27e956.png";